import {
  Link as LinkIcon,
  LockOpen as LockOpenIcon,
  People as PeopleIcon,
  Storefront as StorefrontIcon,
  SupervisedUserCircle as SupervisedUserCircleIcon,
  TableChart as TableChartIcon,
  ViewModule as ViewModuleIcon,
  MonetizationOn as PaymentIcon,
  Payment as ReferencePaymentIcon,
  Repeat as RecurringChargesIcon,
  BugReport as SandboxIcon,
  SyncAlt as TransactionsIcon,
} from '@material-ui/icons';

const access = [
  {
    href: '/access/roles',
    icon: LockOpenIcon,
    module: 'roles',
    title: 'Roles',
  },
  {
    href: '/access/users',
    icon: PeopleIcon,
    module: 'users',
    title: 'Usuarios',
  },
];

const digitalPayment = [
  {
    href: '/digital_payments/payment_links',
    icon: LinkIcon,
    module: 'paymentLink',
    title: 'Links de pago',
  },
  {
    href: '/digital_payments/referenced_payments',
    icon: ReferencePaymentIcon,
    module: 'paymentReferenced',
    title: 'Pago Referenciado',
  },
  {
    href: '/digital_payments/recurring_charges',
    icon: RecurringChargesIcon,
    module: 'paymentRecurring',
    title: 'Cargos Recurrentes',
  },
];

const sandbox = [
  {
    href: '/sandbox/transactions',
    icon: TransactionsIcon,
    module: 'Sandbox',
    title: 'Transacciones',
  },
  {
    href: '/sandbox/commerce',
    icon: StorefrontIcon,
    module: 'Sandbox',
    title: 'Comercios',
  },
  {
    href: '/sandbox/test_matrix',
    icon: TableChartIcon,
    module: 'Sandbox',
    title: 'Matriz de pruebas',
  },
  {
    href: '/sandbox/cards',
    icon: ReferencePaymentIcon,
    module: 'Sandbox',
    title: 'Tarjetas de prueba',
  },
];
export const items = [
  {
    href: '/movements',
    icon: ViewModuleIcon,
    items: [
      {
        href: '/movements/transactions',
        title: 'Transacciones',
      },
      // {
      //   href: '/movements/recurring_charges',
      //   title: 'Cargos recurrentes',
      // },
    ],
    module: 'movements',
    isSandbox: false,
    title: 'Movimientos',
  },
  {
    href: '/reports',
    icon: TableChartIcon,
    module: 'reports',
    isSandbox: false,
    title: 'Reportes',
  },
  // {
  //   href: '/finance',
  //   icon: CreditCardIcon,
  //   items: [
  //     {
  //       href: '/finance/billing',
  //       title: 'Facturación',
  //     },
  //   ],
  //   module: 'finance',
  //   title: 'Finanzas',
  // },
  {
    href: '/commerce',
    icon: StorefrontIcon,
    isSandbox: false,
    module: 'commerces',
    title: 'Comercios',
  },
  // {
  //   href: '/developers',
  //   icon: CodeIcon,
  //   module: 'developers',
  //   title: 'Desarrolladores',
  // },
  {
    href: '/access',
    icon: SupervisedUserCircleIcon,
    items: access,
    module: access.map((item) => item.module),
    title: 'Accesos',
  },
  {
    href: '/payment_links',
    icon: PaymentIcon,
    items: digitalPayment,
    isSandbox: false,
    module: access.map((item) => item.module),
    title: 'Pagos Digitales',
  },
  {
    href: '/sandbox',
    icon: SandboxIcon,
    items: sandbox,
    isSandbox: true,
    module: access.map((item) => item.module),
    title: 'Sandbox',
  },
];
